export default __webpack_public_path__ + "static/media/38.4827332b.jpeg";